const { DataServiceEndPoint } = require("@cloudbreakus/network-utilities")

class Consent extends DataServiceEndPoint {
  static key = "Consent"
  getAppearanceAnalysisConsent = async () => {
    const url = `${this.url}/v1/agents-consent`
    const headers = { Authorization: `bearer ${this.token}` }
    try {
      const result = await this._httpService.get(url, { headers })
      const consent = result?.data
      this._logger.debug(`[DATA] Fetched agent consent for appearance analysis`, {
        consent,
        raw: result,
      })
      return { data: consent }
    } catch (error) {
      this._logger.error(`[DATA] Failed to fetch agent consent for appearance analysis`, error)
      throw error
    }
  }

  setAppearanceAnalysisConsent = async ({ hasOptedIn }) => {
    const url = `${this.url}/v1/agents-consent`
    const headers = { Authorization: `bearer ${this.token}` }
    try {
      const payload = { consent: hasOptedIn }
      return await this._httpService.post(url, payload, { headers })
    } catch (error) {
      this._logger.error(`[DATA] Failed to set agent consent for appearance analysis`, error)
      throw error
    }
  }
}
module.exports = Consent
